import type { ListWorkspaceReviewsData } from '@up2stay/up2promo-api-client';

import type { ReviewsFilterValues } from '@/core/components/reputation/reviews/reviews-filters';

export const REVIEWS_PROVIDER = 'google';
export const LOCATIONS_LIMIT = 200;
export const REVIEWS_PAGE_SIZE = 25;

export function buildReviewsListQuery(
  filters: ReviewsFilterValues,
  debouncedSearch: string,
  page: number,
  pageSize: number,
  focusReviewId?: string,
) {
  return {
    provider: REVIEWS_PROVIDER,
    page,
    pageSize,
    ...(filters.locationIds.length === 1
      ? { locationId: filters.locationIds[0] }
      : filters.locationIds.length > 1
        ? { locationIds: filters.locationIds.join(',') }
        : {}),
    ...(debouncedSearch ? { q: debouncedSearch } : {}),
    ...(filters.sentiments.length === 1
      ? { sentiment: filters.sentiments[0] }
      : filters.sentiments.length > 1
        ? { sentiments: filters.sentiments.join(',') }
        : {}),
    ...(filters.aspects.length === 1
      ? { aspect: filters.aspects[0] }
      : filters.aspects.length > 1
        ? { aspects: filters.aspects.join(',') }
        : {}),
    ...(filters.ratings.length > 0
      ? { ratings: filters.ratings.join(',') }
      : {}),
    ...(filters.tab !== 'all'
      ? { responded: filters.tab === 'answered' ? 'true' : 'false' }
      : {}),
    ...(page === 1 && focusReviewId ? { reviewId: focusReviewId } : {}),
  } as ListWorkspaceReviewsData['query'];
}
